import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationInventoryItemSchema as ConsolidationInventoryItemBaseSchema } from "./consolidation-inventory-item";

const ConsolidationInventoryItemSchema_ =
  ConsolidationInventoryItemBaseSchema.extend({
    availableQuantity: z.number().int(),
    configuredBinAvailableQuantity: z.number().int(),
    dueAt: z.date().nullable(),
    dueByCutoff: z.boolean(),
    eligibilityStatus: z.enum([
      "eligible",
      "registered",
      "registered_and_eligible",
    ]),
    inConfiguredConsolidationBin: z.boolean(),
    packedQuantity: z.number().int(),
    registeredQuantity: z.number().int(),
  });

export const ConsolidationInventoryItemSchema: z.ZodType<ConsolidationInventoryItem> =
  ConsolidationInventoryItemSchema_;
export interface ConsolidationInventoryItem extends z.infer<
  typeof ConsolidationInventoryItemSchema_
> {}

export const listConsolidationInventory = {
  name: "listConsolidationInventory" as const,
  input: z.object({
    consolidationId: consolidationIdFormat.schema,
    cursor: inventoryItemIdFormat.schema.optional(),
    pageSize: z.number().int().min(1).max(500).default(100),
  }),
  output: z.object({
    items: z.array(ConsolidationInventoryItemSchema),
    nextCursor: inventoryItemIdFormat.schema.nullable(),
  }),
};
